import { Link } from 'react-router-dom';
import { Activity } from 'lucide-react';
import CryptoIcon from '../CryptoIcon';
import { formatPair } from '../../utils/commodities';
import { fmtUsd, timeAgo } from './format';

const STATUS = {
  won: 'bg-emerald-500/15 text-emerald-400',
  lost: 'bg-red-500/15 text-red-400',
  active: 'bg-sky-500/15 text-sky-400',
};

export const RecentActivity = ({ items }) => (
  <div className="glow-card p-6 rounded-xl" data-testid="profile-recent-activity">
    <h2 className="text-xl sm:text-2xl font-bold mb-6">Recent Trading Activity</h2>
    {items.length === 0 ? (
      <div className="text-center py-10" data-testid="profile-activity-empty">
        <Activity className="h-10 w-10 text-gray-600 mx-auto mb-3" />
        <p className="text-gray-400 mb-4">No trades yet</p>
        <Link to="/trading" className="inline-block px-5 py-2 rounded-lg bg-purple-600 hover:bg-purple-700 text-sm font-semibold" data-testid="profile-start-trading-link">Start trading</Link>
      </div>
    ) : (
      <div className="space-y-3">
        {items.map((t) => (
          <div key={t.id} className="flex items-center justify-between gap-3 p-4 bg-gray-900/30 rounded-lg hover:bg-gray-900/50 transition-colors" data-testid={`profile-activity-${t.id}`}>
            <div className="flex items-center gap-3 min-w-0">
              <CryptoIcon symbol={t.symbol} size={34} />
              <div className="min-w-0">
                <p className="font-semibold truncate">{t.type === 'arbitrage' ? 'AI Arbitrage' : formatPair(t.symbol)}</p>
                <p className="text-xs text-gray-400">{t.type === 'binary' ? `Binary · ${t.side}` : 'Arbitrage'} · {fmtUsd(t.amount)}</p>
              </div>
            </div>
            <div className="text-right shrink-0">
              <span className={`inline-block px-2.5 py-0.5 rounded-full text-xs font-bold capitalize ${STATUS[t.status] || 'bg-gray-700/40 text-gray-300'}`}>{t.status}</span>
              {t.status !== 'active' && (
                <p className={`text-sm font-semibold mt-1 ${t.profit >= 0 ? 'text-emerald-400' : 'text-red-400'}`}>{t.profit >= 0 ? '+' : ''}{fmtUsd(t.profit)}</p>
              )}
              <p className="text-xs text-gray-500">{timeAgo(t.created_at)}</p>
            </div>
          </div>
        ))}
      </div>
    )}
  </div>
);

export default RecentActivity;
